import api from '@shared/api';
import { UpdateCodeVisualizationTemplate } from '@experiment-management-shared';
import { PanelTemplate, RevisionDetail, TemplateRevision } from './types';

export interface CreatePanelTemplateRequest {
  templateName: string;
  teamId: string;
  code: {
    code: string;
    pyCode: string;
    description: string;
    internalResources: string[];
    pyConfig: string;
    defaultConfig: string;
  };
  scopeType: string;
}

export const createCodePanelTemplate = async (
  payload: CreatePanelTemplateRequest,
  signal?: AbortSignal
): Promise<TemplateRevision> => {
  const response = await api.post(
    '/code-visualizations/template/create',
    payload,
    {
      signal
    }
  );
  return response.data;
};

export const updateCodePanelTemplate = async (
  payload: UpdateCodeVisualizationTemplate,
  signal?: AbortSignal
) => {
  const url = `/code-visualizations/template/update`;
  const response = await api.post<TemplateRevision>(url, payload, {
    signal
  });
  return response.data;
};

export interface getPanelTemplateParams {
  projectId: string;
  templateId: string;
  revisionId?: string | null;
}

export const getPanelTemplate = async ({
  projectId,
  templateId,
  revisionId
}: getPanelTemplateParams): Promise<PanelTemplate> => {
  const res = await api.get('code-visualizations/template/get', {
    params: {
      projectId,
      templateId,
      revisionId
    }
  });
  return res.data;
};

export interface RemovePanelTemplateParams {
  templateId: string;
  scope: string;
}

export const removePanelTemplate = ({
  templateId
}: RemovePanelTemplateParams) => {
  return api.post('code-visualizations/template/delete', {
    templateId
  });
};

interface PanelTemplateRevisionsResponse {
  revisions: number[];
  revisionDetails: RevisionDetail[];
}

export const getTemplateRevisionIds = async ({
  templateId
}: {
  templateId: string;
}): Promise<PanelTemplateRevisionsResponse> => {
  const url = `code-visualizations/template/${templateId}/revisions/`;
  const res = await api.get(url);
  return res.data;
};
